module.exports = __webpack_public_path__ + "themes/fq/img/logo-title.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/logo-title.png
// module id = 63
// module chunks = d-game